export interface IContentBlock {
  contentTypeAlias: string;
  componentName?: string;
  channels?: Channel[];
}

export enum ContentBlockType {
  text = 'text',
  actionList = 'actionList',
  liteActionList = 'liteActionList',
  cardList = 'cardList',
  formattedText = 'formattedText',
  captionedImage = 'captionedImage',
  textList = 'textList',
  partnerLogos = 'partnerLogos',
  highlightedProducts = 'highlightedProducts',
  productOverview = 'productOverview',
  registrationForm = 'registrationForm',
  campaignRegistration = 'campaignRegistration',
  passwordReset = 'passwordReset',
  dashboardOverview = 'dashboardOverview',
  updateProfile = 'updateProfile',
  updatePassword = 'updatePassword',
  updatePromotionPreferences = 'updatePromotionPreferences',
  updatePersonalizationPreferences = 'updatePersonalizationPreferences',
  updateInboxPreferences = 'updateInboxPreferences',
  updatePushPromotionPreferences = 'updatePushPromotionPreferences',
  updatePushServicePreferences = 'updatePushServicePreferences',
  updateBiometricsPreferences = 'updateBiometricsPreferences',
  vouchers = 'vouchers',
  expirations = 'expirations',
  highlightedPromotions = 'highlightedPromotions',
  transactions = 'transactions',
  login = 'login',
  partnerLogin = 'partnerLogin',
  passwordToken = 'passwordToken',
  contactForm = 'contactForm',
  transferPoints = 'transferPoints',
  terminateAccount = 'terminateAccount',
  organizationLogos = 'organizationLogos',
  blockCard = 'blockCard',
  personalData = 'personalData',
  featuredProducts = 'featuredProducts',
  shareAccount = 'shareAccount',
  video = 'video',
  bookingWidget = 'bookingWidget',
  playableWidget = 'playableWidget',
  donationCounter = 'donationCounter',
  banner = 'banner',
  setPassword = 'setPassword',
  shareReferralLink = 'shareReferralLink',
  referralRewards = 'referralRewards',
  inbox = 'inbox',
  typeform = 'typeform',
  emailReset = 'emailReset'
}

export enum ContentBlockRegion {
  primary = 'primary',
  secondary = 'secondary',
  highlighted = 'highlighted',
  partnerPrimary = 'partnerPrimary'
}

export enum Channel {
  web = 'Web',
  app = 'App'
}
